import APIMapper from './APIMapper';
import ButtonController from "../../controllers/ButtonController";
import * as EntityTypes from '../constants/entityTypes';
import { IceBreakerButtonController } from "../../controllers/IceBreakerButtonController";

class ButtonAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;
    
    if (item.dependencies.get(EntityTypes.WIDGET)) {
      return ButtonController.putButton(item.dependencies.get(EntityTypes.WIDGET), item.nextValue)
        .then(onSuccess)
        .catch(onError);
    }
    const iceBreakerId = item.dependencies.get(EntityTypes.ICE_BREAKER);
    const botId = item.dependencies.get(EntityTypes.BOT);
    return IceBreakerButtonController.putIceBreakerButton(botId, iceBreakerId, item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;
  
    if (item.dependencies.get(EntityTypes.WIDGET)) {
      return ButtonController.deleteButton(item.dependencies.get(EntityTypes.WIDGET), item.prevValue.id)
        .then(onSuccess)
        .catch(onError);
    }
    const iceBreakerId = item.dependencies.get(EntityTypes.ICE_BREAKER);
    const botId = item.dependencies.get(EntityTypes.BOT);
    return IceBreakerButtonController.deleteIceBreakerButton(botId, iceBreakerId, item.prevValue.id)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new ButtonAPIMapper();
